import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearCustomRequest, customRequestApis, } from "../../../store/customRequest/actions";
var REQUEST_KEY = "deleteRejectionCodeSet";
export var useDeleteRejectionCodeSet = function () {
    var dispatch = useDispatch();
    var deletedRejectionCodeSetResponse = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.dataCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : null; });
    var deletingRejectionCodeSet = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.loadingCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : false; });
    var errorDeleteRejectionCodeSet = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.errorCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : null; });
    var deleteRejectionCodeSet = function (id) {
        dispatch(customRequestApis({
            requestKey: REQUEST_KEY,
            method: "DELETE",
            path: "/billing/Api/V1/RejectionCodes/".concat(id),
            // extraHeaders: getRejectionCodesUserIdHeader(),
        }));
    };
    var clearDeleteRejectionCodeSet = function () {
        dispatch(clearCustomRequest(REQUEST_KEY));
    };
    useEffect(function () {
        return function () {
            dispatch(clearCustomRequest(REQUEST_KEY));
        };
    }, []);
    return {
        deleteRejectionCodeSet: deleteRejectionCodeSet,
        clearDeleteRejectionCodeSet: clearDeleteRejectionCodeSet,
        deletedRejectionCodeSetResponse: deletedRejectionCodeSetResponse,
        deletingRejectionCodeSet: deletingRejectionCodeSet,
        errorDeleteRejectionCodeSet: errorDeleteRejectionCodeSet,
    };
};
